import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";
import bannerBg from "../../img/markets/banner-bg.webp";
import bannerCandles from "../../img/markets/banner-candles.webp";

const CANDLES = [
  { desktop: { left: "45.97%", top: "168px", w: "183px", h: "755px" }, mobile: { left: "45px", top: "558px", w: "77px", h: "319px" }, clip: { left: "-138.39%", w: "733.07%" } },
  { desktop: { left: "58.07%", top: "229px", w: "163px", h: "673px" }, mobile: { left: "121px", top: "584px", w: "69px", h: "285px" }, clip: { left: "-257.99%", w: "733.07%" } },
  { desktop: { left: "68.85%", top: "121px", w: "183px", h: "755px" }, mobile: { left: "190px", top: "538px", w: "78px", h: "321px" }, clip: { left: "-386.78%", w: "733.07%" } },
  { desktop: { left: "80.95%", top: "168px", w: "183px", h: "755px" }, mobile: { left: "268px", top: "559px", w: "77px", h: "319px" }, clip: { left: "-498.49%", w: "733.07%" } },
];

const REVEAL_COLS = 5;
const REVEAL_ROWS = 4;

const REVEAL_TILES = Array.from({ length: REVEAL_COLS * REVEAL_ROWS }, (_, index) => {
  const col = index % REVEAL_COLS;
  const row = Math.floor(index / REVEAL_COLS);
  const order = (index * 37) % (REVEAL_COLS * REVEAL_ROWS);
  const horizontal = (index + row) % 2 === 0;

  return {
    id: index,
    className: horizontal ? "banner-reveal-x" : "banner-reveal-y",
    style: {
      left: `${(col / REVEAL_COLS) * 100}%`,
      top: `${(row / REVEAL_ROWS) * 100}%`,
      width: `${100 / REVEAL_COLS}%`,
      height: `${100 / REVEAL_ROWS}%`,
      animationDelay: `${80 + order * 60}ms`,
      transformOrigin: horizontal
        ? ((index + row) % 2 === 0 ? "left" : "right")
        : ((index + col) % 2 === 0 ? "top" : "bottom"),
    },
  };
});

function Banner() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="relative bg-[#020202] overflow-hidden min-h-[880px] xl:min-h-[955px]">
      {/* Background */}
      <img src={bannerBg} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover pointer-events-none select-none" />
s
      {/* Candlestick images */}
      {CANDLES.map((c, i) => (
        <React.Fragment key={i}>
          {/* Desktop */}
          <div
            className="hidden xl:block absolute overflow-hidden pointer-events-none"
            style={{ left: c.desktop.left, top: c.desktop.top, width: c.desktop.w, height: c.desktop.h }}
          >
            <img
              src={bannerCandles}
              alt=""
              aria-hidden
              className="absolute max-w-none h-full"
              style={{ left: c.clip.left, width: c.clip.w, top: 0 }}
            />
          </div>
          {/* Mobile */}
          <div
            className="xl:hidden absolute overflow-hidden pointer-events-none"
            style={{ left: c.mobile.left, top: c.mobile.top, width: c.mobile.w, height: c.mobile.h }}
          >
            <img
              src={bannerCandles}
              alt=""
              aria-hidden
              className="absolute max-w-none h-full"
              style={{ left: c.clip.left, width: c.clip.w, top: 0 }}
            />
          </div>
        </React.Fragment>
      ))}

      <div className="hidden xl:block absolute inset-0 z-[5] pointer-events-none overflow-hidden">
        {REVEAL_TILES.map((tile) => (
          <span
            key={tile.id}
            className={`banner-reveal-tile ${tile.className}`}
            style={tile.style}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-[10] glcontainer flex flex-col pt-[70px] xl:pt-[145px] gap-[40px] xl:gap-[154px]">
        {/* Title block */}
        <div className="flex flex-col gap-[20px] xl:max-w-[748px]">
          <p className="font-['Inter'] font-medium text-[12px] xl:text-[14px] text-[#636363] tracking-[1.4px] uppercase leading-[1.2]">
            {t("markets.banner.subtitle")}
          </p>
          <div className="flex flex-col font-['Montserrat'] font-black tracking-[-1.28px]">
            <span className="text-[28px] xl:text-[48px] text-[#e1e1e1] leading-[1.2]">
              {t("markets.banner.line1")}
            </span>
            <span className="text-[40px] xl:text-[96px] text-[#ee5414] leading-[1.2]">
              {t("markets.banner.line2")}
            </span>
          </div>
        </div>

        {/* Desc + CTA block */}
        <div className="flex flex-col gap-[20px] xl:gap-[46px] xl:max-w-[488px]">
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[16px] text-[#bebebe] leading-[1.4]">
            {t("markets.banner.desc")}
          </p>
          <div className="flex items-center">
            <AnimatedCTA href={link} mobile>{t("btn.start-trading")}</AnimatedCTA>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
